import React from "react";
import { ChevronRight } from "lucide-react";
import { DashboardSectionProps } from "../dashboard.types";
import GenderTabs from "./GenderTabs";
import ProfileCarousel from "./ProfileCarousel";

const DashboardSection: React.FC<DashboardSectionProps> = ({
  sectionKey,
  title,
  totalCount,
  activeProfiles,
  activeSection,
  viewAllLabel,
  emptyLabel,
  scoreLabel,
  callLabel,
  viewLabel,
  shareLabel,
  showActions = true,
  layout = "scroll",
  onViewAll,
  onViewProfile,
  onShareProfile,
  onCallProfile,
  renderExtraActions,
  genderTabs,
  badgeLabel,
  badgeClassName,
}) => {
  const hasViewAllPath = Boolean(activeSection?.viewAllPath);

  const viewAllClassName = hasViewAllPath
    ? "text-violet-700 hover:text-violet-900"
    : "cursor-not-allowed text-slate-400";

  const bottomButtonClassName = hasViewAllPath
    ? "bg-violet-600 text-white shadow-[0_10px_24px_rgba(124,58,237,0.20)] hover:bg-violet-700"
    : "cursor-not-allowed bg-slate-100 text-slate-400";

  return (
    <section data-dashboard-section={sectionKey} className="mb-5">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 pl-1">
          <div className="ml-2 flex items-center gap-2">
            <h2 className="text-sm font-semibold text-slate-900">
              {title} ({totalCount})
            </h2>
          </div>

          {genderTabs ? (
            <div className="mt-3">
              <GenderTabs {...genderTabs} />
            </div>
          ) : null}
        </div>

        <button
          type="button"
          onClick={onViewAll}
          disabled={!hasViewAllPath}
          className={`inline-flex shrink-0 items-center gap-1 text-sm font-semibold transition ${viewAllClassName}`}
        >
          {viewAllLabel}
          <ChevronRight size={16} />
        </button>
      </div>

      <ProfileCarousel
        profiles={activeProfiles}
        emptyLabel={emptyLabel}
        scoreLabel={scoreLabel}
        callLabel={callLabel}
        viewLabel={viewLabel}
        shareLabel={shareLabel}
        showActions={showActions}
        layout={layout}
        badgeLabel={badgeLabel}
        badgeClassName={badgeClassName}
        onView={onViewProfile}
        onShare={onShareProfile}
        onCall={onCallProfile}
        renderExtraActions={renderExtraActions}
      />

      <button
        type="button"
        onClick={onViewAll}
        disabled={!hasViewAllPath}
        className={`flex w-full items-center justify-center gap-2 rounded-2xl py-2 text-sm font-semibold transition ${bottomButtonClassName}`}
      >
        {viewAllLabel}
        <ChevronRight size={16} />
      </button>
    </section>
  );
};

export default DashboardSection;